import {ToolbarService, TranslateService} from 'bos-commons';
import {OnInit} from '@angular/core';

export abstract class TitleComponent implements ITitle, OnInit {


    abstract getTitleKey();

    protected constructor(
        protected toolbarService: ToolbarService,
        protected translateService: TranslateService) {
    }

    ngOnInit(): void {

        this.toolbarService.titleBar.next(this.translateService.translateWithArgs(this.getTitleKey()));

    }


}

export interface ITitle {

    getTitleKey(): string;

}
